import React from 'react';
import { IContent, IProduct } from '../../../types';
import { GamesSliderItem } from '../../../types/content';
import { withContent } from '../../../hoc/withContext';
import './GameSliderCardElement.scss';

import { getProductURL, sendEvent, cleanSpaces } from '../../../utils';
import PriceContainer from '../../UI/Price/PriceContainer';

interface IGameSliderCardElementProps {
  context?: IContent;
  index: number;
  info: GamesSliderItem;
  product: IProduct;
}

const GameSliderCardElement = ({ info, product, context }: IGameSliderCardElementProps) => {
  const { config } = context;
  const { tracking } = info;

  const productId = cleanSpaces(info.product.product_id);

  return (
    <div className="element-game_slider_card">
      <a
        href={getProductURL(productId, config.country_code)}
        onClick={() => sendEvent(tracking)}
      >
        {product.promotion_percentage && (
          <span className="flag">-{product.promotion_percentage}%</span>
        )}
        <span
          className="visual"
          style={{ backgroundImage: `url(${product.additional_image_link})` }}
        />
        <span className="info">
          <span className="product-fullname">
            <span className="product-name">
              {product.short_title || product.title}
            </span>
            <span className="product-variant">
              {product.Edition}
            </span>
          </span>
          <PriceContainer product={product} />
        </span>
      </a>
    </div>
  );
};

export default withContent(GameSliderCardElement);
